import { render, staticRenderFns } from "./Minus.vue?vue&type=template&id=f1da9b2a"
import script from "./Minus.vue?vue&type=script&lang=js"
export * from "./Minus.vue?vue&type=script&lang=js"
import style0 from "./Minus.vue?vue&type=style&index=0&id=f1da9b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports